import { generated } from '@varos/research-sdk-api';
import { OptionItemProps } from './optionItemProps';
import { COLOR_MAPPING } from './optionItemConstant';

export function buildOptionItemProps(option: generated.EnumOption): OptionItemProps {
    const colorScheme = COLOR_MAPPING[option.color];
    return {
        id: option.id,
        icon: option.icon,
        label: option.display_name,
        description: option.description,
        colorScheme,
    };
}
